<template>
  <form-section :title="$t('Profiles_Overview_Title_RecentEvents')">
    <rest-list
      :payload="fetchEndpoint"
      :border="false"
      :outline="false"
      :filterable="false"
      :pagination="false"
    >
      <rest-list-column-date
        :sortable="false"
        prop="create_time"
        :title="$t('ProfilesEvents_Field_Timestamp')"
        :width="180"
      />

      <rest-list-column
        prop="event_title"
        :title="$t('ProfilesEvents_Field_Title')"
        :sortable="false"
      />
    </rest-list>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'RecentEvents',

  components: {
    FormSection,
    RestList,
    RestListColumn,
    RestListColumnDate
  },

  props: {
    profileId: {
      type: String,
      required: true
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `event-hits`,
        params: {
          expand: 'event_title',
          sort: '-create_time',
          profile_id: this.profileId,
          'per-page': 3,
          page: 1
        }
      })
    }
  }
}
</script>

<style scoped>
>>> th {
  color: #acb0b5;
  font-size: 12px;
  padding-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/profiles/components/RecentEvents.vue